// The farm's rule (ARFISH, findings #104): a lot may be spread over several
// units, but a unit holds one lot at a time. The app warns and never blocks,
// so split / merge / move keep working with full traceability (a split's new
// lots start in the source lot's unit before they are moved).

type LotLike = { id: string; lotKey?: string | null; productionUnitId?: string | null; stage?: string | null }

/** Active lots already in `unitId`, other than the ones being edited / moved. */
export const otherActiveLotsInUnit = <L extends LotLike>(lots: L[], unitId: string | null | undefined, excludeLotIds: string[] = []): L[] => {
  if (!unitId) return []
  return lots.filter((lot) => (
    lot.productionUnitId === unitId
    && (lot.stage ?? 'Active') === 'Active'
    && !excludeLotIds.includes(lot.id)
  ))
}
